import request from '@/utils/request'

const prefix = '/django_rest/account'
const passportPrefix = '/django_rest/passport'

export default {
  doCompanyLogin (params) {
    return request.post('/django_rest/company/login/', params)
  },
  getSessionAccountInfo (params) {
    return request.get(`${prefix}/session/`, { params })
  },
  getCompanyEmployeeRegisterInfo (companyId, params) {
    return request.get(`/django_rest/company/${companyId}/employee-register/`, { params })
  },
  sendSmsValidateCode (params) {
    return request.post('/django_rest/register/send-validation-code/', params)
  },
  registerCompanyEmployee (companyId, employee) {
    return request.post(`/django_rest/company/${companyId}/employee-register/`, employee)
  },
  doCandidateRegister (params) {
    return request.post('/django_rest/register/', params)
  },
  forgetPassword (params) {
    return request.post('/django_rest/forget-password/', params)
  },
  updateAccountMobile (params) {
    return request.put(`${prefix}/update-mobile/`, params)
  },
  getAccountPageConfigList (params) {
    return request.get('/django_rest/company/hr-page-config/', { params })
  },
  createAccountPageConfig (pageConfig) {
    return request.post('/django_rest/company/hr-page-config/', pageConfig)
  },
  updateAccountPageConfig (pageConfig) {
    return request.put(`/django_rest/company/hr-page-config/${pageConfig.id}/`, pageConfig)
  },
  deleteAccountPageConfig (pageConfig) {
    return request.delete(`/django_rest/company/hr-page-config/${pageConfig.id}/`)
  },
  getLoginInfo (params) {
    return request.get(`${passportPrefix}/login/`, { params })
  },
  login (accountInfo) {
    return request.post(`${passportPrefix}/login/`, accountInfo)
  },
  checkSSO (accountInfo) {
    return request.post(`${passportPrefix}/check-sso/`, accountInfo)
  },
  getThirdPartyLoginInfo (params) {
    return request.get(`${passportPrefix}/third-login/`, { params })
  },
  getLogonAccountNextPage (params) {
    return request.get(`${passportPrefix}/next-page/`, { params })
  },
  registerEmployee (companyId, employeeInfo) {
    return request.post(`${passportPrefix}/employee-register/${companyId}/`, employeeInfo)
  },
  getCreatePasswordCodeInfo (params) {
    return request.get(`${passportPrefix}/create-password/`, { params })
  },
  createPassword (info) {
    return request.post(`${passportPrefix}/create-password/`, info)
  },
  getResetPasswordCodeInfo (params) {
    return request.get(`${passportPrefix}/reset-password/`, { params })
  },
  resetPassword (info) {
    return request.post(`${passportPrefix}/reset-password/`, info)
  },
  inviteConfirmChangeEmail (params) {
    return request.post(`${prefix}/invite-confirm-change-email/`, params)
  }
}
